<template>
    <b-dropdown variant="light">
        <template slot="button-content">
            <i class="fas fa-eye" />
            {{ $t('people.columns') }}
        </template>
        <b-dropdown-form style="max-height:250px; overflow:auto; min-width:240px">
            <div v-for="(colGroup, index) in columnsGroups" :key="index" class="mb-2">
                <strong>{{ colGroup.colGroup }}</strong>
                <b-form-checkbox-group
                    :id="`checkbox-group-` + index"
                    v-model="showColumns"
                    :options="getCheckboxOptions(colGroup.columns)"
                    :name="`flavour-` + index"
                    class="d-flex flex-column"
                    @change="onChange($event)"
                />
            </div>
        </b-dropdown-form>
    </b-dropdown>
</template>

<script>
export default {
    name: 'Columns',
    props: {
        model: {
            type: Array,
            required: true,
        },
        columnsGroups: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            shouldEmit: false,
        }
    },
    methods: {
        onChange(event) {
            this.$emit('update:model', event)
            this.shouldEmit = true
        },
        getCheckboxOptions(columns) {
            return columns.map(column => {
                return {
                    text: column.label,
                    value: column,
                }
            })
        },
    },
    computed: {
        showColumns: {
            get() {
                return this.model
            },
            set() {
                //
            },
        },
    },
    watch: {
        showColumns(newValue, oldValue) {
            this.$emit('change', newValue, oldValue)
            this.shouldEmit = false
        },
    },
}
</script>
